/**
 *
 * Asynchronously loads the component for Sessions
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
